import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ValidationErrors } from '@hero/components/molecules';
import { useValidationErrorsStore } from '@hero/components/providers/ValidationErrorsProvider';
import { ShoppingCart } from '@hero/organisms';
import { useRouteState } from '@hero/routes';
import { useShoppingCart } from '@hero/store/hooks';

import { Footer } from '../Footer';

import { Header } from './Header';
import { Navigation } from './Navigation';
import * as S from './style';
function PageLayout({
  children,
  header,
  navigation,
  //isLoading,
  hasFooter = true,
  fullHeight = false
}) {
  const { t } = useTranslation();

  const { products, updateProducts } = useShoppingCart();

  const {
    shoppingCart: {
      enabled: shoppingCartEnabled = true,
      floatingButton,
      browseShoppingButtonEnabled,
      translation: { emptyCartAddGiftTitle, emptyCartAddGiftDesc, emptyCartAddGiftButtonText } = {}
    } = {}
  } = useRouteState();

  const pageLayoutContentRef = React.useRef(null);

  const { reset: resetValidationErrors } = useValidationErrorsStore();

  useEffect(() => {
    return () => {
      resetValidationErrors();
    };
  }, []);

  useEffect(() => {
    window.pageLayoutContent = pageLayoutContentRef.current;
  }, [pageLayoutContentRef.current]);

  return (
    <S.PageLayout fullHeight={fullHeight}>
      {header && <Header {...header} />}
      <S.PageLayoutContent ref={pageLayoutContentRef}>
        <S.PageLayoutContentInner>
          <ValidationErrors pageLayoutContentRef={pageLayoutContentRef} />
          {children}
        </S.PageLayoutContentInner>
        {hasFooter && <Footer />}
      </S.PageLayoutContent>
      {navigation && <Navigation {...navigation} />}
      {shoppingCartEnabled && (
        <ShoppingCart
          floatingButton={floatingButton}
          browseShoppingButtonEnabled={browseShoppingButtonEnabled}
          products={products}
          onRemoveProduct={product => {
            updateProducts(
              products.filter(sp => sp.merchantProductId !== product.merchantProductId)
            );
          }}
          onClearAll={() => {
            updateProducts([]);
          }}
          translation={{
            emptyCartAddGiftTitle: t(emptyCartAddGiftTitle || 'addYourFirstGifts'),
            emptyCartAddGiftDesc: t(emptyCartAddGiftDesc || 'addYourFirstGiftsDesc'),
            emptyCartAddGiftButtonText: t(emptyCartAddGiftButtonText || 'browseGifts')
          }}
        />
      )}
    </S.PageLayout>
  );
}

PageLayout.propTypes = {
  children: PropTypes.node.isRequired,
  hasFooter: PropTypes.bool,
  header: PropTypes.node,
  navigation: PropTypes.node,
  isLoading: PropTypes.bool,
  fullHeight: PropTypes.bool
};

PageLayout.S = S;

export { PageLayout };
